<template>
  <master-layout pageTitle="Cart Recovery">
    <ion-content>
      <iframe style="width: 100%; height: calc(100% - 56px); border: none;" :src="iframeUrl" title="Cart recovery"></iframe>
    </ion-content>
  </master-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      authData: "auth/getAuthData"
    }),
    iframeUrl() {
      return this.environment('VUE_APP_ROOT') + 's/cart-recovery-iframe?convuser='+ this.authData.token +'&uid='+ this.authData.authkey;
    }
  }
}
</script>